
import Vue, { VueConstructor, PropType } from 'vue'
import CustomTextModal from './CustomTextModal.vue'
import {
  RButton,
  // RCheckbox,
  RInput,
} from '@/components/'

import { Path, Permissions } from '@/store/types/file'
import CopyText from '@/mixins/CopyText'

function hasTruthyValue(object: { [key: string]: boolean }): boolean {
  return Object.values(object).filter((value) => !!value).length > 0
}

type LinkShareData = {
  title: string
  permissions: Permissions
  linkedPaths: Path[]
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof CopyText>>).extend({
  name: 'BrowserItemLinkShare',
  components: {
    CustomTextModal,
    RButton,
    // RCheckbox,
    RInput,
  },
  mixins: [CopyText],
  props: {
    pending: {
      type: Boolean,
    },
    paths: {
      type: Set as PropType<Set<string>>,
    },
    link: {
      type: String,
    },
  },
  data(): LinkShareData {
    return {
      title: '',
      linkedPaths: [],
      permissions: {
        list: true,
        download: true,
        upload: false,
      },
    }
  },
  methods: {
    initializePathsWithPermissions(): void {
      this.paths.forEach((path: string) => {
        this.linkedPaths.push({ path })
      })
    },
    checkAndEmit(): void {
      if (this.permissionPresent) {
        const pathsWithNameAndPermissions = {
          title: this.title,
          paths: this.paths,
          permissions: this.permissions,
        }
        this.$emit('share-link', pathsWithNameAndPermissions)
      }
    },
    reset(): void {
      this.linkedPaths = []
      this.title = ''
      this.permissions = {
        list: true,
        download: true,
        upload: false,
      }
      this.resetCopyTextStatus()
      this.$emit('reset')
    },
    disableCheckBox(permissionName: string): boolean {
      const { pending, link, permissions } = this
      if (!permissions.upload && permissionName === 'list') {
        permissions.list = true
        return true
      }
      if (permissions.download && permissionName === 'list') {
        permissions.list = true
        return true
      }
      return pending || !!link
    },
  },
  computed: {
    permissionPresent(): boolean {
      return hasTruthyValue(this.permissions)
    },

    copyTextBtnTxt(): string {
      return this.successfullyCopiedText ? 'Copied!' : 'Copy link'
    },
  },
})
